<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block my-loan" v-loading="Loading">
      <div class="top-title titles">新闻公告</div>
      <div v-if='list.length'>
        <div class="table" v-for="item in list" :data="item" :key="item.id" @click="detail(item)">
          <div class="tb-row">
            <div class="tb-col title">{{item.title}}</div>
            <div class="tb-col other">时间: {{item.publicTime}}</div>
          </div>
        </div>
      </div>
       <div v-else style=" font-size: 20px; text-align: center;padding-top: 100px;">暂无数据</div>
    </div>
  </div>
</template>

<script>
import HeaderImg from "@/components/HeaderImg";
export default {
  components: {
    HeaderImg,
  },
  data() {
    return {
      search: {
        pageNum: 1,
        pageSize: 100,
        userId: this.$store.state.userInfo.id,
        areaConfigId: this.$store.state.cityArea.areaConfigId,
        systemConfigName:'xyt' 
      },
      list: [],
      total: 0,
      headerList: [
        { name: "首页", path: "/Home" },
        { name: "新闻公告", }
      ],
      Loading: false,
    }
  },
  methods: {
    getDataList() {
      this.Loading = true
      this.$api.user.queryProjectNotices(this.search).then(res => {
        if (res.code == 1000) {
          this.list = res.data
        }
      }).catch((error) => {}).finally(() => {
        this.Loading = false
      })
    },
    detail(row){
      this.$router.push({name: 'MyNoticeDetail', query:{ id: row.id}})
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.getDataList()
  }
}
</script>
<style lang="scss" scoped>
.titles{
  height: 56px;
  line-height: 56px;
  width: 1064px;
  margin: auto;
  color: #fff;
  background-image: linear-gradient(-135deg, #55607B 0%, #394259 100%);
  padding-left: 40px;
}
.titles::before {
    content: " ";
    width: 20px;
    height: 20px;
    background: url("~@/assets/icon/notices.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 15px;
    top: 20px;
}
.my-loan {
  // margin: 0 48px;
  /deep/ .el-form-item {
    margin-right: 18px;
  }
  .table {
    width: 1064px;
    margin: auto;
    cursor: pointer;
    .tb-row {
      .tb-col {
        &.other {
          font-size: 14px;
          color: #999999;
          border-bottom: 1px solid #E9E9E9;
          padding-bottom: 25px;
          padding-left: 15px;
        }
        &.title {
          padding: 25px 0 5px;
          font-size: 18px;
          color: #666666;
        }
        &.title::before {
          content: "";
          width: 5px;
          height: 5px;
          background: #fff;
          border: 2px solid #FC6937;
          border-radius: 50%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>